import React from 'react';

import cookie from 'js-cookie';

import algoliasearch from 'algoliasearch';

const algoliaClient = algoliasearch(
  process.env.GATSBY_ALGOLIA_APP_ID,
  process.env.GATSBY_ALGOLIA_INDEX_API_KEY
);
const productSearchIndex = algoliaClient.initIndex(
  process.env.GATSBY_ALGOLIA_PRODUCT_INDEX
);

productSearchIndex.setSettings({ hitsPerPage: 100 });

export const CHECKOUT_KEY = 'eugenie_checkout';
const NEWSLETTER_KEY = 'eugenie_newsletter';

// const shopify = shop.buildClient({
//   domain: process.env.GATSBY_SHOPIFY_DOMAIN,
//   storefrontAccessToken: process.env.GATSBY_SHOPIFY_STOREFRONT_API_TOKEN,
// });

const ShopContext = React.createContext();
export default ShopContext;

/* eslint-disable react/prop-types */

export class ShopContextProvider extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      // UI
      isCartOpen: false,
      isSearchOpen: false,

      // Customer
      customerEmail: undefined,
      customerName: undefined,
      customerAddress: undefined,
      customerToken: undefined,
      customerOrders: [],
      customerWishLists: [],

      // Checkout
      successMessage: null,
      successMessageColor: null,
      isHydratingCheckout: false,
      searchResults: [],
      hasSeenNewsletter: false,
    };
  }

  componentDidMount = () => {
    this.initCustomer();

    // newsletter
    const newsletterCookie = cookie.get(NEWSLETTER_KEY);

    this.setState({
      hasSeenNewsletter: !!newsletterCookie,
    });
  };

  setCartOpen = (boolean) => {
    this.setState({
      isCartOpen: boolean,
    });
  };

  setSearchOpen = (boolean) => {
    this.setState({
      isSearchOpen: boolean,
    });
  };

  searchStore = (searchTerm) => {
    productSearchIndex
      .search(searchTerm)
      .then(results => {
        this.setState({
          searchResults: results.hits,
        });
      })
      .catch(error => {
        console.log(error);
      });
  };

  setSeenNewsletter = () => {
    cookie.set(NEWSLETTER_KEY, true, { expires: 31 });

    this.setState({
      hasSeenNewsletter: true,
    });
  };

  // Accounts

  initCustomer = async () => {
    console.log('initCustomer');
    const customerEmail = cookie.get('eugenie_customer_email');
    const customerToken = cookie.get('eugenie_customer_token');
    const customerName = cookie.get('eugenie_customer_firstName');
    const customerAddress = cookie.get('eugenie_customer_defaultAddress');

    const request = await fetch(`/api/wishlists?email=${customerEmail}`, {
      method: 'GET',
    });

    const { wishLists = [] } = await request.json();

    if (customerEmail && customerToken && customerName) {
      this.setState({
        customerEmail,
        customerToken,
        customerName,
        customerAddress: customerAddress
          ? JSON.parse(customerAddress)
          : undefined,
      });
    }

    if (wishLists.length) {
      this.setState({
        customerWishLists: wishLists,
      });
    }
  };

  setCustomerInState = () => {
    const customerEmail = cookie.get('eugenie_customer_email');
    const customerToken = cookie.get('eugenie_customer_token');
    const customerName = cookie.get('eugenie_customer_firstName');
    const customerAddress = cookie.get('eugenie_customer_defaultAddress');

    this.setState({
      customerEmail,
      customerToken,
      customerName,
      customerAddress: customerAddress
        ? JSON.parse(customerAddress)
        : undefined,
    });
  };

  setCustomerOrders = (orders) => {
    this.setState({
      customerOrders: orders,
    });
  };

  setCustomerWishLists = (wishLists) => {
    this.setState({
      customerWishLists: wishLists,
    });
  };

  logoutCustomer = () => {
    cookie.remove('eugenie_customer_email');
    cookie.remove('eugenie_customer_token');
    cookie.remove('eugenie_customer_firstName');
    cookie.remove('eugenie_customer_defaultAddress');

    this.setState({
      customerEmail: null,
      customerToken: null,
      customerName: null,
      customerAddress: null,
    });
  };

  render() {
    const value = {
      // values
      isCartOpen: this.state.isCartOpen,
      isSearchOpen: this.state.isSearchOpen,
      searchResults: this.state.searchResults,
      hasSeenNewsletter: this.state.hasSeenNewsletter,
      customerEmail: this.state.customerEmail,
      customerName: this.state.customerName,
      customerAddress: this.state.customerAddress,
      customerToken: this.state.customerToken,
      customerOrders: this.state.customerOrders,
      customerWishLists: this.state.customerWishLists,
      // methods
      setCartOpen: this.setCartOpen,
      setSearchOpen: this.setSearchOpen,
      searchStore: this.searchStore,
      setSeenNewsletter: this.setSeenNewsletter,
      initCustomer: this.initCustomer,
      setCustomerInState: this.setCustomerInState,
      setCustomerOrders: this.setCustomerOrders,
      setCustomerWishLists: this.setCustomerWishLists,
      logoutCustomer: this.logoutCustomer,
    };

    return (
      <ShopContext.Provider value={value}>
        {this.props.children}
      </ShopContext.Provider>
    );
  }
}
